import { useContext, useEffect } from 'react';
import { useHistory } from 'react-router';
import { Route, Switch } from 'react-router-dom';

import AuthenticatedLanding from './AuthenticatedLanding';
import AuthenticatedPrivateRoute from './AuthenticatedPrivateRoute';
import SignInRedirect from './components/common/SignInRedirect';
import SignOut from './components/common/SignOut';
import FAQPage from './components/FAQ';
import CreatePortfolio from './components/portfolios/CreatePortfolio';
import InvitedRedirect from './components/portfolios/InvitedRedirect';
import PortfolioList from './components/portfolios/List';
import PortfolioProperties from './components/portfolios/PortfolioProperties';
import WhatsNewPage from './components/whats-new/WhatsNew';
import { HelpPanelContext } from './contexts/HelpPanelContext';
import { SplitPanelContext } from './contexts/SplitPanelContext';
import Landing from './Landing';
import PortfolioSelected from './PortfolioSelected';

function Routes() {

    const { panelClose } = useContext(HelpPanelContext);
    const { setPanelContent } = useContext(SplitPanelContext);
    const history = useHistory();

    history.listen(() => {
        // when navigating to another page, the help panel should be hidden
        panelClose();
        // set split panel content to undefined so panel will not display by default
        setPanelContent(undefined, '');
    });

    useEffect(() => {
        // If the redirected user had an angular route, their browser url will be replaced with the landing page
        const indexOfAngularRouting = window.location.href.indexOf('#');
        if (indexOfAngularRouting > 0) {
            history.replace('/');
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <Switch>
            <Route exact path="/" component={Landing} />
            <Route exact path="/signin" component={SignInRedirect} />
            <Route exact path="/signout" component={SignOut} />
            <AuthenticatedPrivateRoute exact path="/authenticated" component={AuthenticatedLanding} />
            <AuthenticatedPrivateRoute exact path="/portfolios" component={PortfolioList} />
            <AuthenticatedPrivateRoute exact path="/new-portfolio" component={CreatePortfolio} />
            <AuthenticatedPrivateRoute exact path="/invite/:invitationId" component={InvitedRedirect} />
            <AuthenticatedPrivateRoute exact path="/faq/:faqId?" component={FAQPage} />
            <AuthenticatedPrivateRoute exact path="/whats-new" component={WhatsNewPage} />
            <AuthenticatedPrivateRoute path="/portfolio/:portfolioId/properties" component={PortfolioProperties} />
            <AuthenticatedPrivateRoute path="/portfolio/:portfolioId" component={PortfolioSelected} />
        </Switch>
    );
}

export default Routes;
